import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import {
  Box,
  Button,
  Container,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import { Link } from 'react-router-dom';
import Logo from '../../../../components/Logo/Logo';

/**
 * The component that is showed to the user when they are complete with the client onboarding
 */
const ClientOnboardingComplete = () => {
  const theme = useTheme();
  const isLg = useMediaQuery(theme.breakpoints.up('lg'), {
    defaultMatches: true,
  });
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '2em',
        height: '100%',
        width: '100%',
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} lg={7}>
          <Typography
            fontSize="3em"
            sx={{
              textAlign: {
                xs: 'center',
                lg: 'left',
              },
            }}
          >
            Client Onboarding Complete
          </Typography>
          <Typography
            fontSize="1.2em"
            gutterBottom
            sx={{
              textAlign: {
                xs: 'center',
                lg: 'left',
              },
            }}
          >
            We are excited to partner with your organization and provide
            exceptional training solutions tailored to your organization&apos;s
            needs. Take the next step and access your comprehensive management
            dashboard.
          </Typography>
          <Box
            display="flex"
            justifyContent={isLg ? 'left' : 'center'}
            marginTop={3}
            marginBottom={3}
          >
            <Button
              component={Link}
              to="/management"
              variant="contained"
              endIcon={<ArrowForwardIosRoundedIcon />}
            >
              To Management Dashboard
            </Button>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          lg={5}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Logo showText={!isLg} sizeEm={isLg ? 15 : isMd ? 5 : 3} />
        </Grid>
      </Grid>
    </Container>
  );
};

export default ClientOnboardingComplete;
